import * as angular from 'angular';

import { ComponentDefinition } from '../../models';

class TicketModalNavigationController implements angular.IComponentController {
    currentTicketModalPage: number;
    isLoading: boolean;
    loadingMessage: string;

    static $inject = [];

    goToTicketDetails(): void {
        if (this.currentTicketModalPage) {
            this.currentTicketModalPage = 0;
        }
    }

    goToTicketAttachements(): void {
        if (this.currentTicketModalPage !== 1) {
            this.currentTicketModalPage = 1;
        }
    }
}

export const wtTicketModalNavigation: ComponentDefinition = {
    componentId: 'wtTicketModalNavigation',
    controller: TicketModalNavigationController,
    template: require('./ticketModalNavigation.component.html'),
    controllerAs: 'vm',
    bindings: {
        currentTicketModalPage: '='
    }
};
